<div class="md:w-[400px] p-6">
  <div class="flex justify-between">
    <span class="text-lg">Delete</span>
    <img 
      (click)="closeDialog()"
      [src]="assetUrl + 'icons/x-close.svg'"
      alt="Close"
      class="ml-auto cursor-pointer" />
  </div>

  <div class="py-6">
    <span class="text-md text-gray-600">
      Are you sure you want to delete this category ?
    </span>
  </div>

  <div class="flex border-t border-gray-200 w-full">
    <div class="flex gap-4 pt-6 ml-auto">
      <button
        class="px-6 py-2 shadow rounded-3xl bg-white text-gray-950"
        (click)="closeDialog()"
      >
        Cancel
      </button>
      <button
        class="px-6 py-2 shadow rounded-3xl bg-error-500 text-white"
        (click)="confirmDelete()"
      >
        Delete
      </button>
    </div>
  </div>
</div>
